export async function getList({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.types.index();
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function getMetaList({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.types.getMetaList();
  if (!errResponse && responseData.success) {
    return commit('setMetaList', responseData.data);
  }

  return {};
}

export async function createType({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.types.create(payload);
  commit('setBtnLoading', false, {root: true})
  return response;
}

export async function updateType({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.types.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findTypeById(_, payload) {
  return await this.$adminRepositories.types.show(payload);
}

export async function deleteTypeById({dispatch}, id) {
  const response = await this.$adminRepositories.types.delete(id);
  await dispatch('getList');
  return response;
}

export async function getTypesByCategoryId({commit}, categoryId) {
  const {errResponse, data: responseData} = await this.$adminRepositories.types.getTypesByCategoryId(categoryId);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}
